import NotesIcon from './NotesIcon';
import DiscussionIcon from './DiscussionIcon';

/** Shared navigation for an idea's info and discussion pages. */
export default function NodePanelTabs({ activeTab, onInfo, onDiscuss, palette }) {
  return (
    <nav aria-label="Idea details" style={{ display: 'flex', gap: 4 }}>
      {['info', ...(onDiscuss ? ['discuss'] : [])].map(tab => (
        <button
          key={tab}
          type="button"
          aria-label={tab === 'info' ? 'Notes' : 'Discuss'}
          aria-pressed={activeTab === tab}
          title={tab === 'info' ? 'Notes' : 'Discuss'}
          onClick={tab === 'info' ? onInfo : onDiscuss}
          style={{
            width: 32, height: 30, display: 'grid', placeItems: 'center',
            border: 'none', borderRadius: 7, cursor: 'pointer',
            background: activeTab === tab ? palette.accent : 'transparent',
            color: activeTab === tab ? palette.accentText : palette.text,
            opacity: activeTab === tab ? 1 : 0.6,
          }}
        >
          {tab === 'discuss' ? <DiscussionIcon /> : <NotesIcon />}
        </button>
      ))}
    </nav>
  );
}
